import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
        path: '/',
        name: 'Login',
        component: () =>
            import('@/views/SupplierManager/Login')
    }, {
        path: '/supplier/index',
        name: 'skuQuery',
        meta: {
            title: '首页'
        },
        component: () =>
            import('@/views/SupplierManager/SkuQuery/index.vue')
    }, {
        path: '/material/index',
        name: 'MaterialReportUpload',
        meta: {
            title: '报告单上传'
        },
        component: () =>
            import('@/views/SupplierManager/ReportUpload/index.vue')
    }
    ]
})
